/**
 * Unilar Main Cupons
 * Copy coupon code to clipboard.
 */

class UnilarMainCupons {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    this.section.querySelectorAll('[data-copy-text]').forEach((btn) => {
      if (btn.dataset.cuponsCopyInit === 'true') return;
      btn.dataset.cuponsCopyInit = 'true';

      btn.addEventListener('click', () => {
        const text = btn.dataset.copyText;
        if (!text) return;

        const codeEl = btn.closest('.unilar-main-cupons__code-box')?.querySelector('.unilar-main-cupons__code');
        if (!codeEl) return;

        const defaultLabel = btn.getAttribute('aria-label');

        navigator.clipboard.writeText(text).then(() => {
          if (codeEl.dataset.copyTimeout) {
            window.clearTimeout(Number(codeEl.dataset.copyTimeout));
          }

          codeEl.textContent = 'CUPOM COPIADO';
          codeEl.classList.add('unilar-main-cupons__code--copied');
          btn.setAttribute('aria-label', 'Cupom copiado');

          codeEl.dataset.copyTimeout = String(
            window.setTimeout(() => {
              codeEl.textContent = text;
              codeEl.classList.remove('unilar-main-cupons__code--copied');
              codeEl.removeAttribute('data-copy-timeout');
              btn.setAttribute('aria-label', defaultLabel);
            }, 4000)
          );
        });
      });
    });
  }
}

function initUnilarMainCupons() {
  document.querySelectorAll('[data-unilar-main-cupons]').forEach((section) => {
    if (section.dataset.unilarMainCuponsInit === 'true') return;
    section.dataset.unilarMainCuponsInit = 'true';
    new UnilarMainCupons(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUnilarMainCupons);
} else {
  initUnilarMainCupons();
}

document.addEventListener('shopify:section:load', initUnilarMainCupons);
